import { render, staticRenderFns } from "./SecondStepAssistance.vue?vue&type=template&id=696fb962&"
import script from "./SecondStepAssistance.vue?vue&type=script&lang=js&"
export * from "./SecondStepAssistance.vue?vue&type=script&lang=js&"
import style0 from "./SecondStepAssistance.vue?vue&type=style&index=0&id=696fb962&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports